/* eslint-disable @typescript-eslint/no-explicit-any */
import colors from '@Common/assets/colors';
import { useQueueContext } from '@Context/QueueContext';
import { useTestCaseContext } from '@Context/TestCaseContext';
import { parseRequirements } from '@Generator/history/GenColumns';
import { parseTestCases } from '@Generator/history/PubColumn';
import { GeneratedHistory, PushHistory } from '@Models/types';
import { CheckCircle, Trash } from '@phosphor-icons/react';
import { getFields } from '@Utils/helpers';

import { BounceLoader } from 'react-spinners';

const Task = () => {
  const {
    setViewType,
    setPanelOpen,
    setSelectedGenerated,
    setSelectedPublish,
  } = useTestCaseContext();
  const { queue, removeFromQueue, setQueue, isInProgress } = useQueueContext();

  const isGeneratedHistory = (item: any): item is GeneratedHistory => {
    return 'completion_status' in item;
  };

  const isPushHistory = (item: any): item is PushHistory => {
    return 'push_status' in item;
  };

  const handleView = (queue: GeneratedHistory | PushHistory) => {
    if (isGeneratedHistory(queue)) {
      setSelectedGenerated(queue);
      setViewType('TestCases');
      setPanelOpen(true);
    } else {
      setSelectedPublish(queue);
      setViewType('TestRail');
      setPanelOpen(true);
    }
    removeFromQueue(queue.id);
  };

  const clearQueue = () => {
    setQueue([]);
  };

  return (
    <>
      <div className="flex flex-row items-center justify-between pb-2 text-xs sm:text-sm">
        <div>Tasks</div>
        <Trash
          data-testid="test-clear-btn"
          onClick={() => clearQueue()}
          size={20}
          className="cursor-pointer hover:text-brandRed-500"
        />
      </div>
      {queue.length === 0 && (
        <div className="px-2 text-xs italic">No Tasks in Queue</div>
      )}
      {queue.length > 0 &&
        queue.map((q) => {
          return (
            <div key={q.id} className="flex flex-row">
              <div className="flex w-full flex-row items-center justify-between rounded-md bg-gray-200 p-2">
                <div className="flex flex-row items-center gap-x-2">
                  {!isInProgress(q) && (
                    <div className="animate-pulse">
                      <CheckCircle
                        size={25}
                        weight="fill"
                        className="text-green-500"
                      />
                    </div>
                  )}

                  <span className="flex flex-col gap-x-2 text-xs sm:text-sm">
                    {isGeneratedHistory(q) &&
                      parseRequirements(q.requirements).map((req, index) => (
                        <div key={index}>
                          <label>{getFields(req).id}</label>
                        </div>
                      ))}

                    {isPushHistory(q) &&
                      parseTestCases(q.test_cases).map((tc, index) => (
                        <div key={index}>
                          <label className="text-xs">{tc.name}</label>
                        </div>
                      ))}
                  </span>
                </div>

                {isInProgress(q) && (
                  <BounceLoader size={20} color={colors.brandWarning[500]} />
                )}

                {!isInProgress(q) && (
                  <div className="cursor-pointer">
                    <button
                      className="whitespace-nowrap rounded-md bg-primary-700 px-2 py-1 text-xs text-white"
                      onClick={() => handleView(q)}
                    >
                      View
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </>
  );
};

export default Task;
